export const WIDGET_VERSION = '2.0'
